export default __webpack_public_path__ + "static/media/p8.374c9222.jpg";